

// Custom Error Class
class ErrorModel extends Error {
    constructor(message, functionName, additionalData = {}) {
        super(message);
        this.StackTrace = this.stack;
        this.Details = { ...additionalData };
        this.ErrorTrace = [functionName];
        this.name = 'ErrorModel'
    }

    // Append function call names for tracking
  addFunctionTrace(functionName) {
    this.ErrorTrace.push(functionName);
  }

  // Append additional details dynamically
  addAdditionalDetails(key, value) {
    this.Details[key] = value;
  }

  }  

  // Export a singleton instance
export { 
    ErrorModel
};